var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLupaIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 542.88699 542.44496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lupa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M746.47107,676.32184,597.84735,527.69818C659.8468,444.11786,652.96,325.52545,577.16907,249.73444c-83.377-83.377-218.55768-83.377-301.93463,0s-83.3769,218.55767,0,301.93457c75.944,75.944,194.86059,82.70153,278.46765,20.29809L702.26392,720.529a31.35109,31.35109,0,0,0,44.20709,0l.00006-.00006A31.35109,31.35109,0,0,0,746.47107,676.32184Zm-433.96539-162.677a159.72569,159.72569,0,1,1,227.6911-1.85114c-.43024.38495-.85382.78107-1.26685,1.19409l-.00006.00006c-.4704.4704-.91608.95618-1.3501,1.44886A159.71894,159.71894,0,0,1,312.50568,513.64484Z",
    transform: "translate(-212.70177 -187.20172)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupaIc);
export default __webpack_public_path__ + "static/media/lupa-ic.9e3d27555eaa31d6ff0321aad1ea4e46.svg";
export { ForwardRef as ReactComponent };